import { action, observable } from "mobx";
import ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { ConductorBase } from "@frui.ts/screens";

export default class ModalService extends ConductorBase<ScreenBase> {
  @observable.shallow modals: ScreenBase[] = [];

  @action.bound
  closeChild(viewModel: ScreenBase, forceClose?: boolean) {
    return this.deactivateChild(viewModel, forceClose ?? true);
  }

  protected deactivateChild(child: ScreenBase, isClosing: boolean): Promise<any> {
    this.modals.splice(this.modals.lastIndexOf(child), 1);
    return Promise.resolve(true);
  }

  async tryActivateChild(child: ScreenBase): Promise<boolean> {
    await child.initialize();
    this.modals.push(child);
    this.connectChild(child);
    await child.activate();
    return true;
  }
}
